export const requiredEnv = (key: string): string => {
  const value = process.env[key];
  if (value === undefined) {
    throw new Error("Missing env key: " + key);
  }
  return value;
};
